import http from "@/http/aisea/axios";
const resource = "/enterprises/timesheet/tasks";

export default {
  search(payload) {
    return http.get(`${resource}`, { params: payload });
  },
  add(payload) {
    return http.post(`${resource}`, payload);
  },
  update(enterpriseTimesheetTaskId, payload) {
    return http.put(`${resource}/${enterpriseTimesheetTaskId}`, payload);
  },
  delete(enterpriseTimesheetTaskId) {
    return http.delete(`${resource}/${enterpriseTimesheetTaskId}`);
  },
  sort(enterpriseCrewTaskIds) {
    return http.put(`${resource}/sort`, enterpriseCrewTaskIds);
  },
};
